module.exports = __webpack_public_path__ + "static/media/Sidebar-card-icon-active.496be6b4.svg";